import { LockOutlined, UserOutlined } from '@ant-design/icons'
import { Button, Form, Input, notification } from 'antd'
import Axios from 'axios'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { authAsync, AuthReducerState, IApplicationState } from '../../state'

export const Login: React.FC = props => {
    const state = useSelector<IApplicationState, AuthReducerState>(state => state.auth)
    const dispatch = useDispatch()
    const [form] = Form.useForm()

    React.useEffect(() => {
        if (state.access_token) {
            window.location.href = '/dashboard'
        }
    }, [state.access_token])

    const handleSubmit = () => {
        form.validateFields().then((values: any) => {
            const { username, password } = values
            Axios.post('/auth/login', {
                username,
                password,
            })
                .then((result: any) => {
                    dispatch(authAsync(result.data))
                })
                .catch((error: any) => {
                    notification.error({
                        message: error.message,
                    })
                })
        })
    }

    return (
        <div
            style={{
                maxWidth: '600px',
                border: '1px solid #ebedf0',
                position: 'absolute',
                transform: 'translateY(-50%) translateX(-50%)',
                left: '50%',
                top: '50%',
                background: 'white',
                borderRadius: '5px',
            }}
        >
            <Form form={form} className="login-form" style={{ margin: '30px' }} onFinish={handleSubmit}>
                <h1>IoT Maintenance Dashboard</h1>
                <Form.Item name="username" rules={[{ required: true, message: 'Please input your username!' }]}>
                    <Input prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Username" />
                </Form.Item>
                <Form.Item name="password" rules={[{ required: true, message: 'Please input your Password!' }]}>
                    <Input
                        prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                        type="password"
                        placeholder="Password"
                    />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit" className="login-form-button">
                        Log in
                    </Button>
                </Form.Item>
            </Form>
        </div>
    )
}
